import React from 'react'
import { Paper, Typography, Box, List, CircularProgress, makeStyles } from '@material-ui/core'
import formatCurrency from 'utils/formatCurrency'
import formatCents from 'utils/formatCents'
import ContributionListItem from 'components/MyGivingPage/ContributionListItem'
import formatDateString from 'utils/formatDateString'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import useCurrentUserEntities from 'hooks/useCurrentUserEntities'
import useTransactionListItemSelector from 'hooks/useTransactionListItemSelector'
import AlertWrapper from 'components/AlertWrapper'
import { useHistory } from 'react-router'

const useStyles = makeStyles(({ palette: { grey } }) => ({
  progressUnfilled: {
    color: grey[200],
    position: 'absolute'
  }
}))

export default function Roundups() {
  const { push: redirect } = useHistory()
  const isCurrentlyRoundingUp = useCurrentUserProp('roundedUpJars').length > 0
  const hasRoundups = useCurrentUserProp('mostRecentRoundups').length > 0
  const transactionSelector = useTransactionListItemSelector('Roundup')
  const roundups = useCurrentUserEntities('roundups', 'mostRecentRoundups')
  const classes = useStyles()

  const unprocessedRoundupsSum = useCurrentUserProp('unprocessedRoundupsSum')
  const amountLeftUntilWithdrawal = 5 - unprocessedRoundupsSum

  return (
    <Box component={Paper} p={2}>
      <Typography gutterBottom align='center' variant='h6' component='h2'>
        Roundups
      </Typography>
      {!isCurrentlyRoundingUp && (
        <AlertWrapper
          severity='warning'
          message='You are not currently rounding up. Select causes to roundup to to in community'
          actionHandler={() => { redirect('/home/community') }}
          actionText='go to community'
        />
      )}
      <Box py={1} display='flex' alignItems='center' justifyContent='space-between'>
        <Typography variant='subtitle1'>
          {formatCurrency(amountLeftUntilWithdrawal)} until next $5 total is contributed
        </Typography>
        <Box position='relative'>
          <CircularProgress variant='determinate' value={100} color='primary' className={classes.progressUnfilled} />
          <CircularProgress variant='determinate' value={(unprocessedRoundupsSum / 5) * 100} color='secondary' />
        </Box>
      </Box>

      {hasRoundups ? (
        <List>
          {roundups.map(({ amount, id, percentage }) => {
            const { encodedBankLogo, transactionName, accountName, transactionDate, transactionAmount } = transactionSelector(id)
            const primaryText = `${formatDateString(transactionDate)} ~ ${formatCurrency(transactionAmount)}`

            return (
              <ContributionListItem
                { ...{
                  key: id,
                  primaryText,
                  encodedBankLogo,
                  transactionName,
                  accountName,
                  contribution: `${formatCents(amount)}`
                } }
              />
            )
          })}
        </List>
      ) : (
        <Typography align='center' paragraph variant='body1'>
          You don't have any roundups yet!
        </Typography>
      )}
    </Box>
  )
}
